import { DataGrid } from "@mui/x-data-grid";
import TabPanel from "@mui/lab/TabPanel";
import DecisionTree from "../../questions/DecisionTree";

/**
 * @component Decision Tree Overview Component
 * this component displays the questions and you have to answer and submit your answers
 * 
 * @param {function} setDecisionTreeAnswers
 * @param {function} handleDecisionTreeReset
 * @param {function} handleDecisionTreeSubmit
 * @param {boolean} showTable
 * @param {array} decisionTreeIngredients
 * @param {boolean} loading
 * @param {array} columns
 * @param {number} decisionTreeCurrentPage
 * @param {number} decisionTreePageSize
 * @param {function} setDecisionTreeCurrentPage
 * @param {function} openDrawer
 * @param {function} setDecisionTreePageSize
 * @returns {JSX.Element} Decision Tree Overview Component
 */
export default function DecisionTreeOverview({ setDecisionTreeAnswers, handleDecisionTreeReset, handleDecisionTreeSubmit, showTable, decisionTreeIngredients, loading, columns, decisionTreeCurrentPage, decisionTreePageSize, setDecisionTreeCurrentPage, openDrawer, setDecisionTreePageSize }) {
  return (
    <TabPanel value="3">
      <DecisionTree
        setDecisionTreeAnswers={setDecisionTreeAnswers}
        onSubmit={handleDecisionTreeSubmit}
        onReset={handleDecisionTreeReset}
      />

      {showTable &&
        decisionTreeIngredients?.ingredientsData?.length > 0 && (
          <DataGrid
            autoHeight
            rows={decisionTreeIngredients?.ingredientsData || []}
            loading={loading}
            columns={columns}
            pagination
            pageSize={decisionTreePageSize}
            pageSizeOptions={[10, 15, 20, 25, 50, 75, 100]}
            paginationModel={{
              page: decisionTreeCurrentPage,
              pageSize: decisionTreePageSize,
            }}
            onPaginationModelChange={(model) => {
              setDecisionTreeCurrentPage(model.page);
              setDecisionTreePageSize(model.pageSize);
            }}
            onRowClick={(params) => {
              openDrawer(params.row);
            }}
          />
        )}
    </TabPanel>
  );
}